import React from 'react';
import { useDrop } from 'react-dnd';
import { DragFieldObject } from '../../section-field-manager/interface/section-update-config';

interface IPlainDragDrop {
  addFieldOnPlainSection(dragItem: DragFieldObject): void;
}

const PlainDragDrop: React.FC<IPlainDragDrop> = (props) => {

  // eslint-disable-next-line
  const [collectedProps, dropRef] = useDrop({
    accept: 'field',
    drop: (item: DragFieldObject) => {
      props.addFieldOnPlainSection(item);
    }
  })
  return <div ref={dropRef} className="drag-and-drop" >
    Drag and drop fields here
    </div>
}

export default PlainDragDrop;
